import { useMutation, useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { PaymentCard } from '../../__generated__/graphql';

export const useDoctorCustomerPaymentMethods = (customerId: string) => {
  const { data, loading, refetch } = useQuery(
    graphql(`
      query doctorPaymentMethods($customerId: String) {
        paymentMethodsForCustomer(customerId: $customerId) {
          id
          cardLastFour
          cardType
        }
      }
    `),
    {
      variables: { customerId },
    },
  );

  const [removeTokenMutation] = useMutation(
    graphql(`
      mutation doctorRemoveToken($customerId: String, $id: String) {
        removeToken(customerId: $customerId, id: $id)
      }
    `),
  );

  const removeToken = async (card: PaymentCard) => {
    if (!confirm(`Remove ${card?.cardType} ending in ${card?.cardLastFour}`)) return;

    await removeTokenMutation({
      variables: {
        customerId,
        id: card?.id,
      },
    });

    await refetch();
  };

  return { loading, data: (data?.paymentMethodsForCustomer ?? []) as PaymentCard[], removeToken };
};
